import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../auth.service';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';

@Component({
  selector: 'app-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss']
})
export class SsoLoginComponent implements OnInit {

  text = 'Proszę czekać...';

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _authService: AuthService,
    private readonly _toastrService: ToastrService
  ) { }

  ngOnInit() {
    const params = this._route.snapshot.queryParams;

    console.log(localStorage.getItem('state'));
    if (params.state === localStorage.getItem('state')) {
      this._authService.lorealLoginGetToken(params.code)
        .pipe(
          catchError((error) => {
            this._toastrService.error(error.error);
            this._router.navigate(['/auth/login']);
            return throwError(() => error);
          }),
          tap((resp: any) => {
            if (resp.token) {
              sessionStorage.setItem('userToken', JSON.stringify(resp));
              setTimeout(() => {
                this._router.navigate(['/']);
              }, 100);
            }
          })
        )
        .subscribe();
    } else {
      this._router.navigate(['/']);
      this._toastrService.error('Niepoprawny status logowania. Spróbuj ponownie.');
      // this._router.navigate(['/auth/login']);
    }
  }

}
